import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./schema";
import { SESSION_TOKEN_KEY } from "../client/use-session-token";

console.log({ baseUrl: import.meta.env.VITE_API_URL });

const fetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.VITE_API_URL,
  credentials: "include",
  fetch: async (...args) => {
    // @ts-expect-error type mismatch
    const response = (await window.interceptedFetch?.(...args)) || fetch(...args);
    const data = await response.clone().json().catch(() => null);
    const token = data?.token ?? data?.data?.token;
    if (token) {
      localStorage.setItem(SESSION_TOKEN_KEY, token.slice(0, -12));
    }
    return response;
  },
});

export const $api = createClient(fetchClient);

export const workerFetchClient = fetchClient;

export const productionFetchClient = createFetchClient<paths>({
  baseUrl: "https://api2.baback.co/",
  credentials: "include",
  fetch: async (...args) => {
    // @ts-expect-error type mismatch
    const response = (await window.interceptedFetch?.(...args)) || fetch(...args);
    const data = await response.clone().json().catch(() => null);
    const token = data?.token ?? data?.data?.token;
    if (token) {
      localStorage.setItem(SESSION_TOKEN_KEY, token.slice(0, -12));
    }
    return response;
  },
});

export { fetchClient };
